import { createListAtoms } from "../../common/DataList";
import tools from "../../../helpers/tools";

// ============================================================
// Page Suspension / Remobilisation (Directeur) — configuration pure de la
// liste : filtres par défaut, définitions des champs, construction de la
// requête. Options de filtre côté client ; les libellés affichés dans le
// tableau viennent, eux, de l'API (outcomeLabel, statusLabel…).
// ============================================================

export const DEMANDES_ENDPOINT = "sanctions/suspension-remobilisation/recherche";

export const STATUTS = [
  { id: "EN_ATTENTE_VALIDATION", name: "À valider" },
  { id: "VALIDEE", name: "Validée" },
  { id: "REFUSEE", name: "Refusée" },
  { id: "A_TRAITER", name: "À traiter (allocataire non résolu)" },
  { id: "LEVEE_DE_SAISINE", name: "Levée de saisine enregistrée (ancien circuit)" },
];
export const ISSUES = [
  { id: "REMOBILISATION", name: "Remobilisation" },
  { id: "LEVEE_DE_SAISINE", name: "Levée de saisine" },
];
export const ORIGINES = [
  { id: "ESPOAR", name: "Référent unique" },
  { id: "FRANCE_TRAVAIL", name: "France Travail" },
];

// À l'ouverture, la page montre ce que le Directeur a à faire : les demandes à
// valider. « Réinitialiser » revient à ce préréglage ; « Tous » dans le statut
// élargit à tout l'historique.
export const DEMANDES_DEFAULT_FILTERS = {
  terms: "",
  status: "EN_ATTENTE_VALIDATION",
  outcome: "",
  origin: "",
  dateDebut: "",
  dateFin: "",
};

export const demandesAtoms = createListAtoms({ defaultFilters: DEMANDES_DEFAULT_FILTERS });

export const DEMANDES_FILTER_GROUPS = [
  { id: "demande", title: "Demande" },
  { id: "periode", title: "Période" },
];

// Le statut est le filtre principal (barre de recherche) ; nature et origine
// n'ont que deux valeurs (options jointes, un clic) ; les dates forment une
// période. Mêmes clés envoyées à l'API.
export const DEMANDES_FILTER_DEFINITIONS = [
  {
    name: "status",
    group: "demande",
    label: "Statut",
    type: "select",
    principal: true,
    size: "lg",
    firstOptionLabel: "Tous",
    options: STATUTS,
  },
  {
    name: "outcome",
    group: "demande",
    label: "Nature de la demande",
    chipLabel: "Demande",
    type: "segmented",
    firstOptionLabel: "Toutes",
    options: ISSUES,
  },
  {
    name: "origin",
    group: "demande",
    label: "Origine",
    type: "segmented",
    firstOptionLabel: "Toutes",
    options: ORIGINES,
  },
  {
    name: "periode",
    group: "periode",
    label: "Demandée",
    type: "dateRange",
    from: "dateDebut",
    to: "dateFin",
    fromLabel: "Demandée à partir du",
    toLabel: "Demandée jusqu'au",
  },
];

const text = (value) => (value === undefined || value === null ? "" : value);

export function buildDemandesPayload(search) {
  const f = { ...DEMANDES_DEFAULT_FILTERS, ...(search.filters || {}) };
  return {
    filters: {
      terms: text(f.terms),
      status: text(f.status),
      outcome: text(f.outcome),
      origin: text(f.origin),
      dateDebut: text(f.dateDebut),
      dateFin: text(f.dateFin),
    },
    page: Number(search.page) || 1,
    nbItemsByPage: Number(search.nbItemsByPage) || 25,
  };
}

// Ce que vise une demande, en une ligne : la sanction appliquée ou l'inscription à retirer.
export const cibleDemande = (d) => {
  if (d.targetedSanction) {
    return `${d.targetedSanction.label}${
      d.targetedSanction.epDate ? ` (EP du ${tools.formatDate(d.targetedSanction.epDate)})` : ""
    }`;
  }
  if (d.targetedEpRegistration) {
    return `Inscription à l'EP du ${tools.formatDate(d.targetedEpRegistration.epDate)}`;
  }
  return "Aucune commission concernée";
};

// Le compteur dit ce qu'on regarde : « 3 demandes à valider » tant que le
// préréglage est en place, « 3 demandes » dès qu'on élargit.
export const COUNT_LABELS_A_VALIDER = {
  none: "Aucune demande à valider",
  one: "demande à valider",
  many: "demandes à valider",
};
export const COUNT_LABELS = { none: "Aucune demande", one: "demande", many: "demandes" };
